import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class ShortTextApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { id, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const data = value === CANTRATE_ID ? { cantRate: true } : { text: value as string };

        return {
            question: id,
            data: [{ ...data, bool: true, comment }],
            comment,
        };
    }

    public validate({ params: { maxLength, minLength, required }, responseActor }: QuestionContext): boolean {
        const response = responseActor.getSnapshot().context;
        const value = response.value as string;

        if (!required || Number(value) === CANTRATE_ID) return true;

        if (typeof minLength === 'number' && value?.length < minLength) {
            return false;
        }

        if (typeof maxLength === 'number' && value?.length > maxLength) {
            return false;
        }

        return Boolean(value) && value.length > 0;
    }
}
